import { CREATE_STOCK_REQUEST_REQUEST, CREATE_STOCK_REQUEST_SUCCESS, CREATE_STOCK_REQUEST_ERROR } from '../types';
export const createStockRequestRequest = () => {
  return {
    type: CREATE_STOCK_REQUEST_REQUEST
  };
};
export const createStockRequestSuccess = _ref => {
  let {
    email,
    product
  } = _ref;
  return {
    type: CREATE_STOCK_REQUEST_SUCCESS,
    email,
    product
  };
};
export const createStockRequestError = error => {
  return {
    type: CREATE_STOCK_REQUEST_ERROR,
    error: true,
    payload: error
  };
};
export const createStockRequest = options => {
  return async (dispatch, _getState, _ref2) => {
    let {
      chord
    } = _ref2;
    const {
      email,
      product
    } = options;
    dispatch(createStockRequestRequest());
    try {
      await chord.oms.createStockRequest({
        stockRequest: {
          email,
          sku: product.variant.sku
        }
      });
      dispatch(createStockRequestSuccess({
        email,
        product
      }));
    } catch (error) {
      dispatch(createStockRequestError(error));
      throw error;
    }
  };
};